import { getData, postData } from '../plugins/ApiCalls'

export function savePartialLeadSettings(data) {
  return postData('partial/settings', data)
}
export function getGlobalPartialSetting() {
  return getData('get/partial/settings')
}
